module.exports = __webpack_public_path__ + "src/assets/img/index_banner.c211c616.png";